import { useMutation } from 'react-query'

import { queryClient } from '../..'
import api from '../../services/api'

export default function useSaveEquipment() {
  return useMutation(
    (values) =>
      api.put(`/report/${values.id}`, values).then((res) => res.data),
    {
      onMutate: (values) => {
        queryClient.cancelQueries('reports')

        const oldReports = queryClient.getQueryData(['reports', values.id])

        queryClient.setQueryData(['reports', values.id], values)

        return () => queryClient.setQueryData(['reports', values.id], oldReports)
      },
      onError: (error, values, rollback) => rollback(),
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries('reports')
        queryClient.invalidateQueries(['reports', variables.id])
      },
    }
  )
}
